export const DOCUMENT_ATTACHMENT_LIMIT = 6;

export enum ModalKeys {
  AdjustmentModal = "adjustmentModal",
  AdjustmentResponseModal = "adjustmentResponseModal"
}
